import classnames from 'classnames'
import React from 'react'

import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import ProductPageSectionProps from '@src/quince-site-pdp/src/domains/ProductPageSectionProps'

import { getSectionDetailsForDevices, checkIsNewLongFormSectionHidden } from '../../../helper/product.helper'

import Section from './components/Section'
import { isRowOfImageTextBlocksSectionDataValid } from './rowOfImageTextBlocks.helpers'
import styles from './rowOfImageTextBlocks.module.scss'

function RowOfImageTextBlocks(props: ProductPageSectionProps | BundlePageSectionProps) {
  const product = 'bundle' in props ? props.bundle : props.product
  const { desktopSectionDetails, mobileSectionDetails } = getSectionDetailsForDevices(
    product,
    CUSTOM_SECTION_TYPE.ROW_OF_IMAGE_TEXT_BLOCKS,
  )

  const isSectionHiddenDesktop =
    isRowOfImageTextBlocksSectionDataValid(desktopSectionDetails) &&
    checkIsNewLongFormSectionHidden(desktopSectionDetails)
  const isSectionHiddenMobile =
    isRowOfImageTextBlocksSectionDataValid(mobileSectionDetails) &&
    checkIsNewLongFormSectionHidden(mobileSectionDetails)

  return (
    <>
      {desktopSectionDetails && !isSectionHiddenDesktop && (
        <Section
          sectionDetails={desktopSectionDetails}
          containerClassName={classnames(styles.container, 'desktopOnly')}
        />
      )}
      {mobileSectionDetails && !isSectionHiddenMobile && (
        <Section
          sectionDetails={mobileSectionDetails}
          containerClassName={classnames(styles.container, 'mobileOnly')}
        />
      )}
    </>
  )
}

export default RowOfImageTextBlocks
